import XbrlAnalysisService from 'app/services/XbrlAnalysisService';
import BaseAnalysisLoadPageMixin from 'app/mixins/BaseAnalysisLoadPageMixin';

export default {
  mixins: [ BaseAnalysisLoadPageMixin ],

  created() {
    this.service = XbrlAnalysisService;
    this.label = 'Analisi bilancio';
    this.analysisType = 'xbrl';
    this.findPage = 'XbrlAnalyses';
    this.editorComponent = 'xbrl-analysis';
  },
};
